import type { TCreditPurpose, TCreditSecurityType, TProductType } from 'constants/dictionaries';

import { mapLocalDictionary } from 'shared/lib/mapDictionaries';

import type { TOffersFiltersIncomingDictionaries } from '../types';

export const mapDictionary = (payload: Partial<TOffersFiltersIncomingDictionaries>) => {
  const { purposes = [], securityTypes = [], productTypes = [] } = payload ?? {};

  return {
    purposes: mapLocalDictionary<TCreditPurpose>(purposes),
    securityTypes: mapLocalDictionary<TCreditSecurityType>(securityTypes),
    productTypes: mapLocalDictionary<TProductType>(productTypes),
  };
};
